'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _glamor = require('glamor');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalStyles = function (_Component) {
  _inherits(GlobalStyles, _Component);

  function GlobalStyles() {
    _classCallCheck(this, GlobalStyles);

    return _possibleConstructorReturn(this, (GlobalStyles.__proto__ || Object.getPrototypeOf(GlobalStyles)).apply(this, arguments));
  }

  _createClass(GlobalStyles, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _glamor.css.global('html', {
        width: '100%',
        height: '100%',
        margin: 0,
        background: _theme2.default.backgrounds.tint1.backgroundColor
      });

      _glamor.css.global('body', {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '100%',
        minHeight: '100%',
        margin: 0,
        fontFamily: _theme2.default.fonts.sans,
        fontSize: _theme2.default.textStyles.body1.fontSize,
        fontWeight: _theme2.default.textStyles.body1.fontWeight,
        letterSpacing: _theme2.default.textStyles.body1.letterSpacing
      });

      _glamor.css.global('body > div:first-child', {
        // This is meant as a robust way to make flexed layouts work for React roots
        // This makes the assumption that the div is the #root
        display: 'flex',
        flex: 1,
        width: '100%'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return GlobalStyles;
}(_react.Component);

exports.default = GlobalStyles;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/GlobalStyles.js
// module id = 583
// module chunks = 0